module.exports = __webpack_public_path__ + "img/info.fc824904.svg";